module.exports = __webpack_public_path__ + "static/img/isRotate.7a426ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articleManage/isRotate.png
// module id = Qn5g
// module chunks = 1